import { render, staticRenderFns } from "./AddDept.vue?vue&type=template&id=72df3058&"
import script from "./AddDept.vue?vue&type=script&lang=js&"
export * from "./AddDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports